<template>
  <div id="contenedor-editar-licitacion">
    <v-form v-model="formularioValido" ref="agregarObrasLicitacion">
      <v-card>
        <v-card-title class="secondary--text">
          Agregar Obras a la licitación
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
            <SelectObrasListasAdjudicar v-model="licitacion.obras" sinBordes>
            </SelectObrasListasAdjudicar>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3"
          >
          </custom-button>
          <custom-button
            @click="mixActualizarLicitacion"
            tipo="formAceptar"
            label="Agregar"
            :disabled="!formularioValido || enviandoFormulario"
          >
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import LICITACION from '@/graphql/querys/administracion/licitaciones/licitacion.gql';
import ACTUALIZAR_LICITACION from '@/graphql/mutations/administracion/licitaciones/actualizarLicitacion.gql';

import CustomButton from '@/components/buttons/Button.vue';
import SelectObrasListasAdjudicar from '@/components/ObrasListasAdjudicar.vue';

export default {
  name: 'EditarLicitacion',
  components: {
    CustomButton,
    SelectObrasListasAdjudicar,
  },
  props: {
    licitacionEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      licitacion: {
        tipo: this.licitacionEditar.tipo,
        numero: this.licitacionEditar.numero,
        caracter: this.licitacionEditar.caracter,
        normatividad: this.licitacionEditar.normatividad,
        objeto: this.licitacionEditar.objeto,
        numeroConvocatoria: this.licitacionEditar.numeroConvocatoria,
        fechaConvocatoria: this.licitacionEditar.fechaConvocatoria,
        fechaInicio: this.licitacionEditar.fechaInicio,
        fechaTermino: this.licitacionEditar.fechaTermino,
        plazo: this.licitacionEditar.plazo,
        anticipoMaterial: this.licitacionEditar.anticipoMaterial,
        anticipoInicio: this.licitacionEditar.anticipoInicio,
        obras: [],
      },
    };
  },
  methods: {
    async mixActualizarLicitacion() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_LICITACION,
        variables: {
          id: this.licitacionEditar.id,
          licitacion: this.licitacion,
        },
        update: (store, { data: { actualizarLicitacion } }) => {
          const query = {
            query: LICITACION,
            variables: {
              id: this.$route.params.idLicitacion,
            },
          };
          try {
            const data = store.readQuery(query);
            data.licitacion = actualizarLicitacion;
            store.writeQuery({ ...query, data });
          } catch (e) {
            // Query not in cache yet
          }
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    limpiarFormulario() {
      this.$refs.agregarObrasLicitacion.reset();
      this.licitacion.obras = [];
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
